/* sb-dc-yardflag.js - Yard Sign and the four flag shapes as design center
   products. 2026-09-09, sizes revised 2026-09-10.

   Until now window.__CAT held five categories and neither of these was in it,
   so "Create Your Design Online" on a yard sign opened the design center on
   the fallback product - a Custom Vinyl Banner at 8ft x 4ft, priced by the
   square foot. Same for every flag.

   Both are FIXED SIZE products, so they are modelled on the retractable
   banner entry: unit 'in', fixedOnly, one preset, one price.

   PRINT SIZES ARE READ OFF THE PRODUCT PHOTOS (2026-09-10, all fourteen
   checked in the browser). Three sets of numbers have been in play: B2Sign's
   spec table, the cut-line bounding box measured off B2Sign's template PDFs,
   and the size printed on each product's own featured image on
   stickersbanners.com. The board has to agree with what the customer reads on
   the product page, so the photo wins. Mostly the photos match the spec table
   - but NOT always, so do not assume: Feather Convex (Small) reads 20 x 82,
   not the 23.5 x 78.5 of the angled small, and the Econo is 30.75 wide, not
   30. Both were wrong here until the photos were actually read. If a photo is
   ever redone with different numbers, change the row to match it.

   ONE DECIMAL PLACE ONLY. Measured 2026-09-09: a board of 32.54 x 78.64 shows
   $0.00 because the bundle's price lookup never matches a two-decimal size
   key, while 31 x 90.5 and 31.5 x 80 price fine. r1() below rounds every row
   to a tenth of an inch - at most 0.05" off, which is nothing on a 7ft flag,
   and the alternative is a flag that looks free. This is why the teardrops
   read 23.2 / 32.5 / 40.4 rather than the 23.17 / 32.54 / 40.38 on the photo.

   sb-dc-flagshape.js normalises each die line to whatever box is set here, so
   the silhouette follows these numbers automatically.

   The catalogue lives inside the 341 KB app bundle, which the theme API will
   not take in one write, so the categories are spliced into window.__CAT at
   runtime - the same approach as sb-dc-popupbackdrop.js.

   Diagnostics: window.__dcYardFlag(). */
(function () {
  'use strict';

  function r1(n) { return Math.round(+n * 10) / 10; }

  function sign(handle, name, wIn, hIn, price, material, viewFt) {
    wIn = r1(wIn); hIn = r1(hIn);
    var key = wIn + 'x' + hIn;
    var by = {}; by[key] = price;
    return {
      handle: handle,
      name: name,
      nameKo: name,
      material: material,
      materialEn: material,
      unit: 'in',
      w: wIn, h: hIn,
      fixedOnly: true,
      noFinishing: true,
      viewFt: viewFt || 10,
      qty: 1,
      presetsIn: [key],
      priceBySizeIn: by,
      optNames: { w: 'Width (Inches)', h: 'Height (Inches)' }
    };
  }

  var YARD = [
    sign('yard-sign', 'Yard Sign', 24, 18, 15.53,
         '24" x 18" \u00b7 4mm corrugated plastic \u00b7 H-stake optional', 3)
  ];

  /* handle, label, width in, height in, cheapest variant price
     width/height exactly as printed on the product's featured image */
  var FLAG_ROWS = [
    ['feather-angled-flag-small',   'Feather Angled Flag (Small)',   23.5,  78.5,  134.99],
    ['feather-angled-flag-medium',  'Feather Angled Flag (Medium)',  24.0,  104.0, 143.99],
    ['feather-angled-flag-large',   'Feather Angled Flag (Large)',   28.0,  138.0, 152.99],
    ['feather-angled-flag-x-large', 'Feather Angled Flag (X-Large)', 24.0,  183.5, 179.99],
    ['feather-convex-flag-small',   'Feather Convex Flag (Small)',   20.0,  82.0,  134.99],
    ['feather-convex-flag-medium',  'Feather Convex Flag (Medium)',  24.0,  104.0, 143.99],
    ['feather-convex-flag-large',   'Feather Convex Flag (Large)',   28.0,  138.0, 152.99],
    ['teardrop-flag-small',         'Teardrop Flag (Small)',         23.17, 63.52, 134.99],
    ['teardrop-flag-medium',        'Teardrop Flag (Medium)',        32.54, 78.64, 143.99],
    ['teardrop-flag-large',         'Teardrop Flag (Large)',         40.38, 101.63, 103.49],
    ['rectangle-flag-small',        'Rectangle Flag (Small)',        31.0,  90.5,  211.49],
    ['rectangle-flag-medium',       'Rectangle Flag (Medium)',       31.0,  114.0, 233.99],
    ['rectangle-flag-large',        'Rectangle Flag (Large)',        31.0,  151.5, 257.39],
    ['econo-feather-flag',          'Econo Feather Flag',            30.75, 137.75, 152.99]
  ];

  var FLAGS = FLAG_ROWS.map(function (row) {
    return sign(row[0], row[1], row[2], row[3], row[4],
                r1(row[2]) + '" x ' + r1(row[3]) + '" print \u00b7 4oz polyester, dye sublimated \u00b7 '
                + 'pole and base chosen on the product page', 12);
  });

  var GROUPS = [
    { cat: 'Yard Signs', items: YARD },
    { cat: 'Flags', items: FLAGS }
  ];

  var HANDLES = {};
  YARD.concat(FLAGS).forEach(function (i) { HANDLES[i.handle] = i; });

  var info = { installed: false, forced: 0, product: null };
  window.__dcYardFlag = function () { return info; };

  function install() {
    var C = window.__CAT;
    if (!Array.isArray(C) || !C.length) return false;
    for (var i = 0; i < C.length; i++) {
      if (C[i] && C[i].cat === 'Flags') { info.installed = true; return true; }
    }
    /* after the banners, before the stickers */
    var at = C.length;
    for (var c = 0; c < C.length; c++) {
      if (/sticker/i.test(C[c].cat || '')) { at = c; break; }
    }
    C.splice.apply(C, [at, 0].concat(GROUPS));
    info.installed = true;
    return true;
  }

  /* ?product=<one of ours> has to land on the right board. The app reads the
     handle at boot, before this file can have spliced anything in, so the
     board is set here as well - the same "nudge until it sticks" shape
     sb-dc-tplfix.js uses for its own presets. */
  function wanted() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return null; }
    var h = q.get('product') || '';
    return HANDLES[h] || null;
  }

  function force() {
    var it = info.product;
    if (!it) return true;
    var a = window.__dcApi;
    if (!a || !a.spec || typeof a.setSpec !== 'function') return false;
    var s = a.spec;
    if (Math.abs(+s.widthIn - it.w) < 0.02 && Math.abs(+s.heightIn - it.h) < 0.02) return true;
    a.setSpec({ widthIn: it.w, heightIn: it.h, __dcProd: it.handle });
    info.forced++;
    return false;
  }

  info.product = wanted();

  var tries = 0;
  var boot = setInterval(function () {
    tries++;
    var done = install();
    var set = force();
    if ((done && set) || tries > 120) clearInterval(boot);
  }, 250);
  install();
})();

/* --------------------------------------------------------------------------
   Two companion files ride along with this one:

     sb-dc-flagopts.js    no finishing on these fifteen products, and the real
                          Shopify options (H-stake / graphic / hardware) in the
                          right rail, resolved to the right variant at checkout
     sb-dc-flagshape.js   the board drawn in the shape of the flag, one die
                          line per shape AND size, from the B2Sign templates

   They are loaded from here rather than from sections/sb-design-center.liquid
   so that section file - which carries Korean comments the theme API has
   rejected on re-upload before - does not have to be rewritten to add two
   script tags. The CDN url is taken from this file's own src, so it keeps
   working across theme copies. If the section file is ever rewritten for
   other reasons, moving these two into it is the tidier home.

   BUMP TAG WHEN EITHER COMPANION CHANGES. A theme asset written through
   asset_url carries Shopify's own ?v= content hash, but these two are built
   by string surgery on this file's src, so they would inherit THIS file's
   hash and a browser that has them cached would keep the old copy until this
   file changed too - which is exactly what happened on 2026-09-09 (the rail
   still showed full prices after the upcharge rewrite went live). TAG is the
   version instead: change it, and this file, whenever flagopts or flagshape
   is re-uploaded.                                                           */
(function () {
  'use strict';
  var here = '';
  try {
    var s = document.currentScript;
    if (!s) {
      var all = document.getElementsByTagName('script');
      for (var i = all.length - 1; i >= 0; i--) {
        if ((all[i].src || '').indexOf('sb-dc-yardflag.js') > -1) { s = all[i]; break; }
      }
    }
    here = (s && s.src) || '';
  } catch (e) {}
  if (!here) return;
  var TAG = '5';
  var base = here.split('?')[0];
  ['sb-dc-flagopts.js', 'sb-dc-flagshape.js'].forEach(function (name) {
    try {
      var url = base.replace('sb-dc-yardflag.js', name) + '?v=' + TAG;
      if (document.querySelector('script[src*="' + name + '"]')) return;
      var t = document.createElement('script');
      t.src = url;
      t.defer = true;
      (document.head || document.documentElement).appendChild(t);
    } catch (e) {}
  });
})();
